<template>
  <div class="home-wrapper">
    <div class="nav">
      <navbar />
    </div>

    <div class="main">
      <router-view />
    </div>
    <div class="footer"><foota /></div>
  </div>
</template>
<script>
import foota from "./components/Foota.vue";
import navbar from "./components/Navbar.vue";
export default {
  components: {
    navbar,
    foota,
  },
  setup() {
    return {};
  },
};
</script>
<style >
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  text-decoration: none;
}

@font-face {
  font-family: boombox;
  src: url("./fonts/BoomBox.ttf") format("TrueType");
}
body {
  background: url("./assets/redsplatter.webp");
  background-attachment: fixed;
  background-position: right center;
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-align: center;
  min-width: 300px;
  margin: auto;
}
#app {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-align: center;
  margin: auto;
}

.home-wrapper {
  display: flex;
  min-width: 100%;
  flex-direction: column;
  min-height: 100vh;
}
.home-wrapper .main {
  flex: 1;
}

.main {
  margin-top: 110px;
}

.footer {
  background-color: rgb(0, 0, 0);
  margin: 0 auto;
  display: flex;
  min-width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  height: 60px;
}
</style>
